import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Gleap from "gleap";

export default function GleapReinitWatcher() {
  const location = useLocation();

  useEffect(() => {
    // Gleap disabled for now
    // Gleap.getInstance().softReInitialize();
  }, [location]);

  return null;
}